import type { IntentsUserId } from "../../../types/intentsUserId"

export type PrivateBalanceQueryKey = [
  "intents_sdk.private_balance",
  { userId: null | IntentsUserId; tokenIds?: string[] },
]

export function privateBalanceQueryKey(
  userId: null | IntentsUserId,
  tokenIds?: string[]
): PrivateBalanceQueryKey {
  return ["intents_sdk.private_balance", { userId, tokenIds }]
}
